import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildAuthRequestHeaders } from "./authRequestHeaders";

function resolveHeaders(getAuthHeaders) {
  if (typeof getAuthHeaders === "function") return getAuthHeaders();
  return buildAuthRequestHeaders();
}

function client(getAuthHeaders) {
  return axios.create({
    baseURL: getApiBase(),
    headers: resolveHeaders(getAuthHeaders),
  });
}

export async function listDatacenterLayouts(getAuthHeaders) {
  const { data } = await client(getAuthHeaders).get("/datacenter-layouts");
  return Array.isArray(data?.layouts) ? data.layouts : [];
}

export async function getDatacenterLayout(id, getAuthHeaders) {
  const { data } = await client(getAuthHeaders).get(`/datacenter-layouts/${encodeURIComponent(id)}`);
  return data?.layout || null;
}

export async function createDatacenterLayout(payload, getAuthHeaders) {
  const { data } = await client(getAuthHeaders).post("/datacenter-layouts", payload);
  return data?.layout || null;
}

export async function updateDatacenterLayout(id, payload, getAuthHeaders) {
  const { data } = await client(getAuthHeaders).put(
    `/datacenter-layouts/${encodeURIComponent(id)}`,
    payload
  );
  return data?.layout || null;
}

export async function deleteDatacenterLayout(id, getAuthHeaders) {
  await client(getAuthHeaders).delete(`/datacenter-layouts/${encodeURIComponent(id)}`);
}
